import { isSmallScreen } from './utils';
export const tagReplacer = () => {
    function debounce(func, delay) {
        let timeoutId;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    }
    function replaceHTagWithP() {
        if (isSmallScreen()) {
            const elementTags = document.querySelectorAll('.dynamic-element-tag');
            elementTags.forEach((el) => {
                if (el.tagName.toLowerCase() === 'p') {
                    const hTagElement = document.createElement('h2');
                    hTagElement.textContent = el.textContent;
                    for (let i = 0; i < el.attributes.length; i++) {
                        const attr = el.attributes[i];
                        hTagElement.setAttribute(attr.name, attr.value);
                    }
                    el.parentNode.replaceChild(hTagElement, el);
                }
                if (el.tagName.toLowerCase() === 'h2') {
                    const pTagElement = document.createElement('p');
                    pTagElement.textContent = el.textContent;
                    for (let i = 0; i < el.attributes.length; i++) {
                        const attr = el.attributes[i];
                        pTagElement.setAttribute(attr.name, attr.value);
                    }
                    el.parentNode.replaceChild(pTagElement, el);
                }
            });
        }
    }
    const debouncedReplaceH2WithP = debounce(replaceHTagWithP, 250);
    replaceHTagWithP();
    window.addEventListener('resize', debouncedReplaceH2WithP);
};
